import { ChangeDetectorRef, Component, Inject, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MAT_DIALOG_DATA, MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatSelectModule } from '@angular/material/select';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { PersonService, ResponsiblePriestCandidate } from '../services/person.service';

export interface ResponsiblePriestDialogData { personId: string; personName: string; responsiblePriestId?: string; }

@Component({
  selector: 'app-responsible-priest-dialog', standalone: true,
  imports: [CommonModule, MatDialogModule, MatButtonModule, MatFormFieldModule, MatSelectModule, MatProgressSpinnerModule],
  templateUrl: './responsible-priest-dialog.component.html', styleUrl: './responsible-priest-dialog.component.scss',
})
export class ResponsiblePriestDialogComponent implements OnInit {
  candidates: ResponsiblePriestCandidate[] = [];
  selectedId: string | null;
  loading = true;
  saving = false;
  error: string | null = null;
  constructor(@Inject(MAT_DIALOG_DATA) readonly data: ResponsiblePriestDialogData, private readonly service: PersonService, private readonly cdr: ChangeDetectorRef, public readonly ref: MatDialogRef<ResponsiblePriestDialogComponent, boolean>) { this.selectedId = data.responsiblePriestId ?? null; }
  ngOnInit(): void { this.service.getResponsiblePriestCandidates(this.data.personId).subscribe({ next: x => { this.candidates = x; this.loading = false; this.cdr.markForCheck(); }, error: () => { this.error = 'No se pudieron cargar los pastores disponibles.'; this.loading = false; this.cdr.markForCheck(); } }); }
  save(): void { this.saving = true; this.error = null; this.cdr.markForCheck(); this.service.updateResponsiblePriest(this.data.personId, this.selectedId).subscribe({ next: () => this.ref.close(true), error: error => { this.error = error?.error?.detail ?? 'No se pudo actualizar el pastor de hogar.'; this.saving = false; this.cdr.markForCheck(); } }); }
}
